import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  page: {
    height: "100%",
    margin: "auto",
    maxWidth: "500px",
    display: "flex",
    flexDirection: "column",
  },
});

export default useStyles;
